import React from 'react';
import { Provider } from 'react-redux';
import firebase from 'firebase';
import * as serviceWorker from './serviceWorker';

import { sentrySetup } from './utils/sentry/sentrySetup';

// Initialize Sentry before anything else
sentrySetup();

import { name as AppName } from './app.json';
import { ReactReduxFirebaseProvider } from 'react-redux-firebase';
import { AppRegistry, View, ActivityIndicator, Platform, StyleSheet } from 'react-native';
import { enableScreens } from 'react-native-screens';
import 'react-native-gesture-handler';
import { PersistGate } from 'redux-persist/integration/react';

import { reduxfbConfig } from './constants/firebase';
import { store, persistor } from './store/store';
import { installSessionAuth } from './helpers/sessionAuth';
import App from './App';

// After Firebase is initialized (store) and before the first API call.
installSessionAuth();

// require('react-native-vector-icons/fonts');
// import { freshChatNotifInit } from './utils/localnotification';

// Use prebuilt version of RNVI in dist folder
import Icon from 'react-native-vector-icons/dist/MaterialCommunityIcons';

// Generate required css
import iconFont from './assets/fonts/MaterialCommunityIcons.ttf';
const iconFontStyles = `@font-face {
  src: url(${iconFont});
  font-family: MaterialCommunityIcons;
}`;

// Create stylesheet
const style = document.createElement('style');
style.type = 'text/css';
if (style.styleSheet) {
  style.styleSheet.cssText = iconFontStyles;
} else {
  style.appendChild(document.createTextNode(iconFontStyles));
}

document.head.appendChild(style);

// Inject stylesheet

import './i18n';

if (Platform.OS === 'ios') {
  enableScreens();
}

class PersistLoader extends React.Component {
  render() {
    return (
      <View style={styles.fullScreenCentered}>
        <ActivityIndicator size="large" color="#3cd070" />
      </View>
    );
  }
}

const Audit = () => {
  const rrfProps = {
    firebase,
    config: reduxfbConfig,
    dispatch: store.dispatch
  };

  //set init
  // freshChatNotifInit();

  return (
    <View style={styles.appRoot}>
      <Provider store={store}>
        <PersistGate persistor={persistor} loading={<PersistLoader />}>
          <ReactReduxFirebaseProvider {...rrfProps}>
            <View style={styles.appRoot}>
              <App />
            </View>
          </ReactReduxFirebaseProvider>
        </PersistGate>
      </Provider>
    </View>
  );
};

const styles = StyleSheet.create({
  appRoot: {
    flex: 1,
    minHeight: '100vh'
  },
  fullScreenCentered: {
    flex: 1,
    minHeight: '100vh',
    justifyContent: 'center',
    alignItems: 'center'
  }
});

serviceWorker.register({});

// console.disableYellowBox = true;
AppRegistry.registerComponent('Audit', () => Audit);
AppRegistry.runApplication(AppName, {
  rootTag: document.getElementById('root')
});
